import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc WellViewAdministration defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { WellViewAdministrationService } from 'services/wellViewAdministration';
 *
 * // create service instance and send/cancel request
 * const wellViewAdministrationService = new WellViewAdministrationService();
 * const result = await wellViewAdministrationService.fetchData( '<user-id>' ); // fetch data
 * wellViewAdministrationService.cancel(); // cancel an active request
 */
export class WellViewAdministrationService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { data = {}, url = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const title = get( response, 'body.component.structure.title', {} );
            const fields = get( response, 'body.component.structure.fields', {} );
            const collapsedSettings = get( response, 'body.component.structure.collapsedSettings', {} );
            const actions = get( response, 'body.component.structure.actions', {} );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    title,
                    fields: getVisibleItems( fields, visibility ),
                    collapsedSettings: getVisibleItems( collapsedSettings, visibility ),
                    actions: getVisibleItems( actions, visibility ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // make request and fetch data
    async fetchSettingsInfo( { data = {}, url = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract widgets from the response
            const settingInformation = get( response, 'body.component.data.state', {} );
            const subWidgets = get( response, 'body.component.structure', {} );
            const options = get( response, 'body.component.data.options', {} );
            const visibility =  get( response, 'body.component.visibility', {} );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    settingInformation,
                    subWidgets,
                    options,
                    visibility
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // make request and fetch data
    async saveSettingsInfo( { data = {}, url = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {},
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
